import { useState } from 'react';
import { Box, Divider, Text } from '@bitrise/bitkit';
import ContentWrapper from '@/components/page/ContentWrapper';
import ProtectedPage from '@/components/page/ProtectedPage';
import PublicBuildPage from '@/components/page/PublicBuildPage/PublicBuildPage';
import BuildsSection from '@/pages/App/AppDetails/components/BuildsSection/BuildsSection';
import { ScheduledBuild } from '@/pages/App/AppDetails/components/ScheduledBuilds/scheduledBuilds.types';
import BuildListFilters from '@/pages/App/AppDetails/types/BuildListFilters';
import AppDetailsPageProps from '@/pages/App/types/AppDetailsPageProps';
import { AppPageLayout } from '../components/AppPageLayout';
import BuildFilters from './components/BuildFilters';

export const AppDetailsPageContent = (
  props: AppDetailsPageProps & { setScheduledBuild: (build: ScheduledBuild) => void },
) => {
  const { app, abilities, isViewedAsPublicPage, setScheduledBuild } = props;

  const [filters, setFilters] = useState<BuildListFilters>({
    term: '',
    status: null,
    triggerType: null,
    branch: null,
    pipelineable: null,
    beforeDate: null,
    afterDate: null,
    artifactType: null,
  });

  return (
    <Box display="flex" flexDir="column" minH="100%">
      <Box paddingTop={[16, 32]} paddingBottom={app.hasAnyBuild ? 12 : [16, 32]} paddingInline={[16, 32]}>
        <Text as="h2" textStyle="heading/h2">
          Builds
        </Text>
        {app.hasAnyBuild && <BuildFilters appSlug={app.slug} setFilters={setFilters} />}
      </Box>
      <Divider />
      <Box backgroundColor="neutral.95" flex="1">
        <ContentWrapper display="flex" flexDirection="row" paddingY="24" gap="16" alignItems="start">
          <Box display="flex" flexDirection="column" flexGrow="1" maxWidth="100%" gap="16">
            <BuildsSection
              app={app}
              abilities={abilities}
              filters={filters}
              isViewedAsPublicPage={isViewedAsPublicPage}
              onUpdateScheduledBuild={setScheduledBuild}
            />
          </Box>
        </ContentWrapper>
      </Box>
    </Box>
  );
};

const AppDetailsPage = (props: AppDetailsPageProps) => {
  const {
    app,
    abilities,
    isViewedAsPublicPage,
    workflowsInfoShown,
    shouldShowFailedPaymentNotification,
    isWatchingApp,
    isOwnerUser,
  } = props;

  const [scheduledBuild, setScheduledBuild] = useState<ScheduledBuild>();

  const PageWrapper = isViewedAsPublicPage ? PublicBuildPage : ProtectedPage;

  return (
    <PageWrapper footerBackground="background/primary" withoutFooter minH="100vh">
      <AppPageLayout
        abilities={abilities}
        app={app}
        currentPage="Builds"
        isOwnerUser={isOwnerUser}
        isViewedAsPublicPage={isViewedAsPublicPage}
        isWatchingApp={isWatchingApp}
        onStartOrScheduleBuildDialogClose={() => setScheduledBuild(undefined)}
        scheduledBuild={scheduledBuild}
        shouldShowFailedPaymentNotification={shouldShowFailedPaymentNotification}
        workflowsInfoShown={workflowsInfoShown}
      >
        <AppDetailsPageContent {...props} setScheduledBuild={setScheduledBuild} />
      </AppPageLayout>
    </PageWrapper>
  );
};

export default AppDetailsPage;
